import React from 'react';

import ReactPlayer from 'react-player'

import helpers from '../lib/helpers';

export default class Video extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      playerShowing: false
    }
  }

  videoClicked(e) {
    e.preventDefault();
    this.setState({
      playerShowing: true
    });
  }

  render() {
    let hasThumb = typeof this.props.contentItem.thumbnailImgUrl != 'undefined',
        isDesktop = helpers.isDesktop(),
        ratio = hasThumb ? (this.props.contentItem.height / this.props.contentItem.width) : 0.5,
        contentsWrapper = window ? document.querySelector('.s-inside__body') : null,
        windowWidth = window && contentsWrapper ? contentsWrapper.clientWidth : (this.props.hasSideBar?750:1020),
        calculatedHeight = windowWidth * ratio;

    return (
      <div className="e-video__wrapper">
        {hasThumb && !this.state.playerShowing && 
          <div className="e-video__inner">
            <a 
              href={this.props.contentItem.videoUrl}
              target="_blank"
              className="e-video__link"
              onClick={this.videoClicked.bind(this)}
            >
              <img 
                src={this.props.contentItem.thumbnailImgUrl} 
                alt="sample image" 
              />
            </a>
          </div>
        }
        {((hasThumb && this.state.playerShowing) || !hasThumb) &&
          <div id="player">
            <ReactPlayer 
              url={this.props.contentItem.videoUrl} 
              playing={hasThumb && isDesktop}
              controls={false}
              height={calculatedHeight}
              width={windowWidth}
            />
          </div>
        }          
      </div>
    );
  }
}